import React from "react";

function CartHeader() {

  return (
     <>
       <div className="legenda_cart">
         <div className="legenda_articoli_cart">
           <p>Prodotti</p>
         </div>
         <div className="legenda_prezzo_cart">
           <p>Prezzo</p>
         </div>
         <div className="legenda_qta_cart">
           <p>Quantità</p>
         </div>
         <div className="legenda_totale_cart">
           <p>Totale</p>
         </div>
       </div>
       <div className="AW-clear"></div>
     </>
   );
}

export default CartHeader;
